import useProfileCommonStore from '../use-profile-common-store';
import { useProfileUnderlyingInvestments } from '../../../hooks/api';
import { PROFILE_API_TYPES } from '../../../hooks/api/_constants';
import _remove from 'lodash/remove';
import _head from 'lodash/head';
import { useEffect, useState } from 'react';
import DISCLOSURES from '../../../helpers/statics/underlying-investments';

const moneyMarketDisclosureByType = {
  'Mutual Fund': DISCLOSURES.baseMoneyMarketDisclosure,
  'CREF Variable Annuity': DISCLOSURES.crefMoneyMarketDisclosure
};

const useUnderlyingInvestments = () => {
  const [asOfDate, setAsOfDate] = useState('');
  const [fixedAnnuityFunds, setFixedAnnuityFunds] = useState([]);
  const [tsvFunds, setTsvFunds] = useState([]);
  const [fundTypesToDisplay, setFundTypesToDisplay] = useState([]);
  const [moneyMarketDisclosure, setMoneyMarketDisclosure] = useState(undefined);
  const { apiConfigBase } = useProfileCommonStore();
  const apiConfig = { ...apiConfigBase, apiType: PROFILE_API_TYPES.prop };

  const { data = [] } = useProfileUnderlyingInvestments(apiConfig);

  const baseFundTypesToDisplay = [];

  useEffect(() => {
    if (data.length > 0) {
      const fixedAnnuities = _remove(data, fund => {
        return fund.fundType === 'TIAA Fixed Annuity';
      });

      const moneyMarkets = _head(
        data.filter(fund => {
          return fund.assetClass === 'Money Market';
        })
      );
      const moneyMarketFundType = moneyMarkets ? moneyMarkets.fundType : null;
      setMoneyMarketDisclosure(moneyMarketDisclosureByType[moneyMarketFundType]);

      const stableValues = _remove(data, fund => {
        return fund.fundType === 'TIAA Stable Value';
      });

      setAsOfDate(data[0].asOfDate || '');
      setFixedAnnuityFunds(fixedAnnuities);
      setTsvFunds(stableValues);

      data.forEach(fund => {
        if (!baseFundTypesToDisplay.includes(fund.fundType)) {
          baseFundTypesToDisplay.push(fund.fundType);
        }
      });
      setFundTypesToDisplay(baseFundTypesToDisplay);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    asOfDate,
    fixedAnnuityFunds,
    fundsToDisplay: data,
    fundTypesToDisplay,
    moneyMarketDisclosure,
    tsvFunds
  };
};

export default useUnderlyingInvestments;
